<em class="fas fa-exclamation-triangle text-danger me-1" role="img" [attr.aria-label]="hint()"></em>
